
<router-outlet></router-outlet>
<sc-confetti></sc-confetti>
